import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPlay: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="play, go"><path d="M5.75 3.31131L20.5208 12L5.75 20.6887V3.31131Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconPlay;
